export { Box } from './box';

export type { BoxProps } from './box';
